import { Component } from '@angular/core';

@Component({
  selector: 'app-plans-loading',
  templateUrl: './plans-loading.component.html',
  styleUrls: ['./plans-loading.component.scss']
})
export class PlansLoadingComponent {

}
